// AuthContext.jsx
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { createSession, getSession, clearSession } from "../Utils/Sessions";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [sessionId, setSessionId] = useState(null);

    // Restore session after refresh
    useEffect(() => {
        const existing = getSession();
        if (existing) setSessionId(existing);
    }, []);

    const createSessionForUser = (username) => {

        setUser(username);

        // 3) create session id at login time
        const sid = createSession();
        setSessionId(sid);
    };

    const value = useMemo(() => ({ user, sessionId, createSessionForUser }), [user, sessionId]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
